module.exports = __webpack_public_path__ + "img/welcome6.0cc945fb.jpg";